import React from 'react';
import { translations } from '../translations';
import '../styles/pages/Features.css';

function Features({ language }) {
  const t = translations[language];

  const features = [
    {
      icon: (
        <svg className="feature-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z" />
        </svg>
      ),
      title: t.feature1Title,
      description: t.feature1Description
    },
    {
      icon: (
        <svg className="feature-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z" />
        </svg>
      ),
      title: t.feature2Title,
      description: t.feature2Description
    },
    {
      icon: (
        <svg className="feature-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
        </svg>
      ),
      title: t.feature3Title,
      description: t.feature3Description
    }
  ];

  const showcases = [
    {
      title: t.showcase1Title,
      description: t.showcase1Description
    },
    {
      title: t.showcase2Title,
      description: t.showcase2Description
    },
    {
      title: t.showcase3Title,
      description: t.showcase3Description
    },
    {
      title: t.showcase4Title,
      description: t.showcase4Description
    },
    {
      title: t.showcase5Title,
      description: t.showcase5Description
    }
  ];

  return (
    <div className="features-page">
      <div className="features-hero">
        <h1>{t.featuresTitle}</h1>
        <p>{t.featuresSubtitle}</p>
      </div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            {feature.icon}
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>

      {/* {showcases.map((showcase, index) => (
        <section key={index} className="feature-showcase">
          <div className="showcase-grid">
            <div className="showcase-content showcase-content-full">
              <h3>{showcase.title}</h3>
              <p>{showcase.description}</p>
            </div>
          </div>
        </section>
      ))} */}
    </div>
  );
}

export default Features;
